export default "__VITE_ASSET__DAQ9dgeE__"